export const _TRANSACTION_STATUS = {
    PENDING: 2,
    SUCCESS: 1,
    EXPIRED: 3,
    INVALID: "QR115"
}

export const REDIRECT_COUNTDOWN_MS = 5000;
export const CHECK_TRANSACTION_MS = 3000;
export const INITIAL_DELAY = 5000;